import React from "react";
import SimilarProductCard from "./SimilarProductCard";
import { useAppSelector } from "../../../State/Store";
import { Product } from "../../../types/productTypes";

const SimilarProduct = () => {
    const { products } = useAppSelector((state) => state.product);

    if (!products || products.length === 0) {
        return <div className="text-gray-500 text-sm">No similar products found.</div>;
    }

    return (
        <div className='grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6 justify-between gap-2 sm:gap-4 gap-y-8'>
            {products.slice(0, 6).map((item: Product) => (
                <SimilarProductCard key={item.id} item={item} />
            ))}
        </div>
    );
};

export default SimilarProduct;